import script from "./accaDnDUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./accaDnDUpload.vue?vue&type=script&setup=true&lang=js"

import "./accaDnDUpload.vue?vue&type=style&index=0&id=d28ad866&lang=scss&scroped=true"

const __exports__ = script;

export default __exports__